export default __webpack_public_path__ + "static/media/whiteenactus.69cf8db9.png";